import { createEntityAdapter } from '@reduxjs/toolkit';

const adapter = createEntityAdapter({});

export const { selectById, selectIds, selectAll } = adapter.getSelectors();

export default adapter;
